import { secureGet } from './http-module';

let holidaysData = {};
const HOLIDAYS_URI = `/api/bff-dashboard/private/holidays`;

export const getHolidaysService = () => {
  return secureGet(HOLIDAYS_URI).then( (data) => {
    holidaysData = data;
    return holidaysData
  });
};